import { render, staticRenderFns } from "./QueryTempuraI.vue?vue&type=template&id=f86f7606&"
import script from "./QueryTempuraI.vue?vue&type=script&lang=js&"
export * from "./QueryTempuraI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports